import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { animate, stagger } from 'animejs';
import './Services.css';
import AnimatedBackground from './AnimatedBackground';

const Services = () => {
  const { t } = useTranslation();
  const gridRef  = useRef(null);
  const leftRef  = useRef(null);

  const navigateToPage = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const services = [
    {
      title: 'Bienestar',
      icon: 'spa',
      description: 'Yoga en vivo, meditación y hábitos conscientes. Clases abiertas, talleres y calendario flexible.',
      button: 'Explorar',
      action: () => navigateToPage('/bienestar'),
      accent: 'nature'
    },
    {
      title: 'Conoce Colombia',
      icon: 'map-marked-alt',
      description: 'Ecoturismo comunitario por Pacífico, Amazonas, Tayrona y San Andrés. Experiencias que respetan la tierra.',
      button: 'Ver viajes',
      action: () => navigateToPage('/conoce-colombia'),
      accent: 'earth'
    },
    {
      title: 'Conecta tu camino',
      icon: 'compass',
      description: 'Coaching online en 7 sesiones para clarificar metas, tomar decisiones y vivir con más propósito.',
      button: 'Primera sesión',
      action: () => navigateToPage('/bienestar#programa-conecta'),
      accent: 'warm'
    },
    {
      title: 'Growth Partner',
      icon: 'chart-line',
      description: 'Ecosistemas digitales basados en datos para marcas que quieren crecer con estrategia y resultados medibles.',
      button: 'Conocer programa',
      action: () => navigateToPage('/growth-partner'),
      accent: 'warm'
    }
  ];

  /* ── Scroll reveal con Anime.js ── */
  useEffect(() => {
    const grid = gridRef.current;
    const left = leftRef.current;
    if (!grid) return;

    const cards = grid.querySelectorAll('.service-card-ecosystem');

    /* Estado inicial: oculto */
    cards.forEach((card) => {
      card.style.opacity   = '0';
      card.style.transform = 'translateY(54px)';
    });
    if (left) {
      left.style.opacity   = '0';
      left.style.transform = 'translateX(-40px)';
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          /* Panel izquierdo */
          if (left) {
            animate(left, {
              opacity   : [0, 1],
              translateX: [-40, 0],
              duration  : 700,
              ease      : 'outExpo',
            });
          }

          /* Tarjetas con stagger */
          animate(cards, {
            opacity   : [0, 1],
            translateY: [54, 0],
            delay     : stagger(110),
            duration  : 650,
            ease      : 'outExpo',
          });

          observer.disconnect();
        });
      },
      { threshold: 0.08 }
    );

    observer.observe(grid);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services services-hero-inverted" id="servicios">
      <AnimatedBackground particleCount={6} staticCount={2} />
      <div className="services-inverted-layout">
        <div className="services-content-side" ref={leftRef}>
          <span className="services-tag">{t('services.tag')}</span>
          <h2 className="services-headline">{t('services.headline')}</h2>
          <p className="services-subtitle">
            {t('services.subtitle')}
          </p>
          <button
            className="services-cta"
            onClick={() => navigateToPage('/servicios')}
          >
            {t('services.viewServices')}
          </button>
        </div>

        <div className="services-grid-side" ref={gridRef}>
          {services.map((s, i) => (
            <div
              key={i}
              className={`service-card-ecosystem service-card-accent-${s.accent}`}
              onClick={s.action}
            >
              <div className="service-card-ecosystem-inner">
                <div className="service-icon-ecosystem">
                  <i className={`fas fa-${s.icon}`}></i>
                </div>
                <h3 className="service-title-ecosystem">{s.title}</h3>
                <p className="service-desc-ecosystem">{s.description}</p>
                <button
                  className="service-btn-ecosystem"
                  onClick={(e) => { e.stopPropagation(); s.action(); }}
                >
                  {s.button}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
